/* eslint-disable */
// Import the functions you need from the SDKs you need
const ZrStatesPricing = [
  {
    wilaya_code: "01",
    name: "أدرار",
    price: 1400,
    stopdesk: "مكتب أدرار",
    pricestopdesk: 900,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "02",
    name: "الشلف",
    price: 750,
    stopdesk: "مكتب الشلف",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "03",
    name: "الأغواط",
    price: 950,
    stopdesk: "مكتب الأغواط",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "04",
    name: "أم البواقي",
    price: 800,
    stopdesk: "مكتب أم البواقي",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "05",
    name: "باتنة",
    price: 800,
    stopdesk: "مكتب باتنة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "06",
    name: "بجاية",
    price: 800,
    stopdesk: "مكتب بجاية",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "07",
    name: "بسكرة",
    price: 950,
    stopdesk: "مكتب بسكرة",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "08",
    name: "بشار",
    price: 1100,
    stopdesk: "مكتب بشار",
    pricestopdesk: 650,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "09",
    name: "البليدة",
    price: 500,
    stopdesk: "مكتب البليدة",
    pricestopdesk: 250,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "10",
    name: "البويرة",
    price: 750,
    stopdesk: "مكتب البويرة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "11",
    name: "تمنراست",
    price: 1600,
    stopdesk: "مكتب تمنراست",
    pricestopdesk: 1050,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "12",
    name: "تبسة",
    price: 850,
    stopdesk: "مكتب تبسة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "13",
    name: "تلمسان",
    price: 850,
    stopdesk: "مكتب تلمسان",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "14",
    name: "تيارت",
    price: 800,
    stopdesk: "مكتب تيارت",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "15",
    name: "تيزي وزو",
    price: 750,
    stopdesk: "مكتب تيزي وزو",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "16",
    name: "الجزائر",
    price: 500,
    stopdesk: "مكتب الجزائر",
    pricestopdesk: 350,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "17",
    name: "الجلفة",
    price: 950,
    stopdesk: "مكتب الجلفة",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "18",
    name: "جيجل",
    price: 800,
    stopdesk: "مكتب جيجل",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "19",
    name: "سطيف",
    price: 750,
    stopdesk: "مكتب سطيف",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "20",
    name: "سعيدة",
    price: 800,
    stopdesk: "مكتب سعيدة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "21",
    name: "سكيكدة",
    price: 800,
    stopdesk: "مكتب سكيكدة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "22",
    name: "سيدي بلعباس",
    price: 800,
    stopdesk: "مكتب سيدي بلعباس",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "23",
    name: "عنابة",
    price: 800,
    stopdesk: "مكتب عنابة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "24",
    name: "قالمة",
    price: 800,
    stopdesk: "مكتب قالمة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "25",
    name: "قسنطينة",
    price: 800,
    stopdesk: "مكتب قسنطينة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "26",
    name: "المدية",
    price: 750,
    stopdesk: "مكتب المدية",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "27",
    name: "مستغانم",
    price: 800,
    stopdesk: "مكتب مستغانم",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "28",
    name: "المسيلة",
    price: 850,
    stopdesk: "مكتب المسيلة",
    pricestopdesk: 500,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "29",
    name: "معسكر",
    price: 800,
    stopdesk: "مكتب معسكر",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "30",
    name: "ورقلة",
    price: 950,
    stopdesk: "مكتب ورقلة",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "31",
    name: "وهران",
    price: 800,
    stopdesk: "مكتب وهران",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "32",
    name: "البيض",
    price: 1100,
    stopdesk: "مكتب البيض",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "33",
    name: "إليزي",
    price: 0,
    stopdesk: "مكتب إليزي",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "34",
    name: "برج بوعريريج",
    price: 750,
    stopdesk: "مكتب برج بوعريريج",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "35",
    name: "بومرداس",
    price: 750,
    stopdesk: "مكتب بومرداس",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "36",
    name: "الطارف",
    price: 800,
    stopdesk: "مكتب الطارف",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "37",
    name: "تندوف",
    price: 0,
    stopdesk: "مكتب تندوف",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "38",
    name: "تيسمسيلت",
    price: 800,
    stopdesk: "مكتب تيسمسيلت",
    pricestopdesk: 520,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "39",
    name: "الوادي",
    price: 950,
    stopdesk: "مكتب الوادي",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "40",
    name: "خنشلة",
    price: 800,
    stopdesk: "مكتب خنشلة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "41",
    name: "سوق أهراس",
    price: 800,
    stopdesk: "مكتب سوق أهراس",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "42",
    name: "تيبازة",
    price: 750,
    stopdesk: "مكتب تيبازة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "43",
    name: "ميلة",
    price: 800,
    stopdesk: "مكتب ميلة",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "44",
    name: "عين الدفلى",
    price: 750,
    stopdesk: "مكتب عين الدفلى",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "45",
    name: "النعامة",
    price: 1100,
    stopdesk: "مكتب النعامة",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "46",
    name: "عين تموشنت",
    price: 800,
    stopdesk: "مكتب عين تموشنت",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "47",
    name: "غرداية",
    price: 950,
    stopdesk: "مكتب غرداية",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "48",
    name: "غليزان",
    price: 800,
    stopdesk: "مكتب غليزان",
    pricestopdesk: 450,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "49",
    name: "تيميمون",
    price: 1400,
    stopdesk: "مكتب تيميمون",
    pricestopdesk: 900,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "51",
    name: "أولاد جلال",
    price: 950,
    stopdesk: "مكتب أولاد جلال",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "52",
    name: "بني عباس",
    price: 1000,
    stopdesk: "مكتب بني عباس",
    pricestopdesk: 900,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "53",
    name: "إن صالح",
    price: 1600,
    stopdesk: "مكتب إن صالح",
    pricestopdesk: 1120,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "54",
    name: "إن قزام",
    price: 1600,
    stopdesk: "مكتب إن قزام",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "55",
    name: "تقرت",
    price: 950,
    stopdesk: "مكتب تقرت",
    pricestopdesk: 600,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "56",
    name: "جانت",
    price: 0,
    stopdesk: "مكتب جانت",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "57",
    name: "المغير",
    price: 950,
    stopdesk: "مكتب المغير",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: true,
  },
  {
    wilaya_code: "58",
    name: "المنيعة",
    price: 1000,
    stopdesk: "مكتب المنيعة",
    pricestopdesk: 0,
    hide: true,
    hidestopdesk: true,
  },
];

export default ZrStatesPricing;
